import PlusLandingPageBase from './PlusLandingPageBase';

export default PlusLandingPageBase;
